import React from 'react';
import { Box, Paper, Typography, alpha } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface KpiCardProps {
  titulo: string;
  valor: string | number;
  variacao?: number;
  icone?: React.ReactNode;
  cor?: string;
  subtitulo?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({
  titulo,
  valor,
  variacao,
  icone,
  cor = '#007AF0',
  subtitulo,
}) => {
  const variacaoPositiva = variacao !== undefined && variacao > 0;

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2.5,
        borderRadius: 2,
        borderTop: `3px solid ${cor}`,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      {/* Titulo + Icone */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="subtitle2" color="text.secondary" fontWeight={500}>
          {titulo}
        </Typography>
        {icone && (
          <Box
            sx={{
              color: cor,
              bgcolor: alpha(cor, 0.1),
              borderRadius: 1,
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icone}
          </Box>
        )}
      </Box>

      {/* Valor principal */}
      <Typography variant="h4" fontWeight={700} sx={{ color: cor, lineHeight: 1.2, mt: 0.5 }}>
        {valor}
      </Typography>

      {/* Variacao + Subtitulo */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 'auto' }}>
        {variacao !== undefined && variacao !== 0 && (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.25,
              px: 0.75,
              py: 0.25,
              borderRadius: 1,
              bgcolor: variacaoPositiva
                ? alpha('#217B00', 0.1)
                : alpha('#D01E29', 0.1),
              color: variacaoPositiva ? '#217B00' : '#D01E29',
            }}
          >
            {variacaoPositiva ? (
              <ArrowUpwardIcon sx={{ fontSize: 14 }} />
            ) : (
              <ArrowDownwardIcon sx={{ fontSize: 14 }} />
            )}
            <Typography variant="caption" fontWeight={600}>
              {variacaoPositiva ? '+' : ''}
              {variacao}%
            </Typography>
          </Box>
        )}

        {subtitulo && (
          <Typography variant="caption" color="text.secondary">
            {subtitulo}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default KpiCard;
